import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    DeploymentRequestResponse,
} from 'app/requests/Deployment/Deployment.types'

const getFields = ({
    disabled,
}: {
    disabled: boolean,
}): DTOCardFormField<keyof DeploymentRequestResponse>[] => {
    return [{
        id: 'deployment',
        title: 'Deployment',
        className: 'deployment',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'deploymentName',
                    componentName: 'InputSingleline',
                    required: true,
                    disabled,
                    labelKey: 'DEPLOYMENT_NAME',
                }],
            },
            {
                id: 'column2',
                className: 'onInfo',
                fields: [
                    {
                        name: 'createdOn',
                        componentName: 'DateTimeSelect',
                        disabled: true,
                        labelKey: 'CREATED_ON',
                    },
                    {
                        name: 'createdBy',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'CREATED_BY',
                    },
                ],
            },
        ],
    }]
}

export default getFields
